import styled from "styled-components";
import { Colors } from "@doordash/design-language";

export const DangerButtonWrapper = styled.div`
  button,
  button:hover {
    box-shadow: 0 0 0 1px ${Colors.GlobalPrimary} inset;
  }
`;
